const mapping = {
  easy: 1,
  medium: 2,
  hard: 3
};

export default mapping;
